export default function () {
	document.addEventListener('DOMContentLoaded', () => {
		const toggleButton = document.getElementById('toggleMapButton');
		const mapContainer = document.getElementById('mapContainer');

		if (toggleButton instanceof Element && mapContainer instanceof Element) {
			toggleButton.addEventListener('click', (e) => {
				e.preventDefault();

				// Přepnutí třídy
				mapContainer.classList.toggle('hidden');
				mapContainer.classList.toggle('expanded');

				// Dynamická změna textu tlačítka
				toggleButton.textContent = mapContainer.classList.contains('hidden')
					? 'Zobrazit mapu'
					: 'Skrýt mapu';
			});
		}
	});
}
